var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMale = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M66.666 13.333v20H60V24.75L46.75 37.917a19 19 0 0 1 2.416 4.958Q50 45.5 50 48.333q0 7.667-5.334 13-5.332 5.334-13 5.334-7.665 0-13-5.334-5.333-5.333-5.333-13t5.333-13Q24.001 30 31.666 30q2.751 0 5.417.792A15.7 15.7 0 0 1 42 33.25L55.25 20h-8.584v-6.667zm-35 23.334q-4.833 0-8.25 3.416T20 48.333t3.416 8.25T31.666 60t8.25-3.417 3.417-8.25-3.417-8.25q-3.416-3.416-8.25-3.416"
})));
export default SvgMale;